import { render, staticRenderFns } from "./calculoPorReceta.vue?vue&type=template&id=6376ac04&"
import script from "./calculoPorReceta.vue?vue&type=script&lang=js&"
export * from "./calculoPorReceta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports